module.exports = __webpack_public_path__ + "static/img/top1.24e6370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top1.png
// module id = cejX
// module chunks = 1